import { useState } from 'react';
import { useFirebase } from '../lib/firebase/FirebaseProvider';
import { useAuth } from '../hooks/useAuth';
import { FeatureAwareNavigation, mobileTabItems } from './FeatureAwareNavigation';
import { AuthModal } from './auth/AuthModal';

const MobileTabBar = () => {
  const { user } = useFirebase();
  const { isAdmin } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authModalRedirect, setAuthModalRedirect] = useState<string | undefined>(undefined);


  return (
    <>
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-urban/10 z-[1000] safe-area-bottom">
        <FeatureAwareNavigation
          items={mobileTabItems}
          user={user}
          isAdmin={isAdmin}
          mobileLayout={true}
          onGuestAction={(action) => {
            if (action === 'AUTH_REQUIRED') {
              setAuthModalRedirect('/submit');
              setShowAuthModal(true);
            }
          }}
          className="flex justify-around items-center py-2 px-2"
          itemClassName={(_, isActive) => 
            `flex flex-col items-center gap-1 px-2 py-2 rounded-lg transition-all duration-200 touch-target ${
              isActive
                ? 'text-cardboard bg-cardboard/10'
                : 'text-urban/60 hover:text-cardboard hover:bg-teddy'
            }`
          }
          renderItem={(item, _, defaultContent) => (
            <div 
              key={item.path} 
              style={{ minWidth: '64px', minHeight: '64px' }}
              className="flex items-center justify-center"
            >
              {defaultContent}
            </div>
          )}
        />
      </div>

      {/* Auth Modal */}
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => {
          setShowAuthModal(false);
          setAuthModalRedirect(undefined);
        }}
        initialMode="login"
        redirectTo={authModalRedirect}
      />
    </>
  );
};

export default MobileTabBar;